import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import TextInputField, { Props as TP } from "./TextInputField";
import { StringUtil } from "@eres/core";
import { conformToMask } from "text-mask-core";
import { isIOS, isiPad, isSafari } from "./EidInputField";
import { defaultValueManager } from "@eres/forms/valuemanager";
import { FormFieldProps, ValueManager } from "@eres/forms";

const isSimple = isSafari() || isIOS() || isiPad();

interface Pros extends TP {
}

export default class MobileInputField extends Component<Pros> {
	render() {
		const { children, ...others } = this.props;
		if ( isSimple ) {
			const vm = new MobileStateValueManager( this.props.valueManager || defaultValueManager );
			return <TextInputField
				maxLength={ 15 }
				{ ...others }
				valueManager={ vm }
			>
				{ children }
			</TextInputField>;
		} else {

		}
		return (
			<TextInputField
				{ ...others }
				customInput={ <MaskedInput
					keepCharPositions={ true }
					guide={ true }
					showMask={ true }
					//  adding plus is causing weired
					mask={ [ "9", "7", "1", "-", /5/, /[0234568]/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ] }
				/> }
			>{ children }
			</TextInputField>
		);
	}
}

class MobileStateValueManager<X = string, XT = string> implements ValueManager<X, XT> {
	om: ValueManager<X, XT>;

	constructor( om: ValueManager<X, XT> ) {
		this.om = om;
	}

	read( props: FormFieldProps<X, XT>, key: string ) {
		let read = this.om.read( props, key );
		if ( StringUtil.isEmptyStringOrNull( read as any ) ) {
			read = "+971-" as any;
			// this.om.write(props, holder, key, read);
		}
		return read;
	}

	write( props: FormFieldProps<X, XT>, key: string, value: any, callback?: () => void ) {
		const r = conformToMask( value, [ "+", "9", "7", "1", "-", /5/, /[0234568]/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ], {
			guide: false,

		} );
		value = r.conformedValue;
		if ( value.endsWith( "-" ) ) {
			value = value.substring( 0, value.length - 1 );
		}
		this.om.write( props, key, value, callback );
	}

}
